module.exports = __webpack_public_path__ + "static/media/ai-ad-ossoff.cd7bfad1.mp4";